import { Button, Result } from "antd";
import { useNavigate } from "react-router-dom";
import PageLayout from "layouts/developerPortal/pageLayout";

function ErrorBoundaryPage() {
  const navigate = useNavigate();

  return (
    <PageLayout>
      <Result
        status="500"
        title="Error"
        subTitle="Sorry, something went wrong."
        extra={
          <Button type="primary" onClick={() => navigate(0)}>
            Refresh Page
          </Button>
        }
      />
    </PageLayout>
  );
}

export default ErrorBoundaryPage;
